/* STEALTH home — reveal-on-scroll, shared across all stealth-* sections.
   Safe to load multiple times (guarded). Re-scans on Shopify section load
   so reveals work inside the theme editor. */
(function () {
  if (window.__stealthHomeInit) {
    window.__stealthReveal && window.__stealthReveal();
    return;
  }
  window.__stealthHomeInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scan() {
    var els = document.querySelectorAll('.stealth-section .reveal:not(.in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  window.__stealthReveal = scan;

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  // Shopify theme editor: re-scan when a section is (re)loaded
  document.addEventListener('shopify:section:load', scan);
})();
